module.exports = {"640221100":"城关镇","640221101":"黄渠桥镇","640221102":"宝丰镇","640221103":"头闸镇","640221104":"姚伏镇","640221105":"崇岗镇","640221106":"陶乐镇","640221200":"高庄乡","640221201":"灵沙乡","640221202":"渠口乡","640221203":"通伏乡","640221204":"高仁乡","640221205":"红崖子乡","640221400":"前进农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640221.json
// module id = 3175
// module chunks = 0